/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FeesAndCharges, RateInfo } from '../navigation/types';

const initialState = {
    ...window.NetBank,
    loanPurposeId: -9999,
    subLoanPurposeId: -9999,
    loanProductName: '',
    loanTypeName: '',
    totalLoanAmount: 0,
    loanTerm: 7,
    standardRate: [
        {
            loanOptionId: 83,
            repaymentPerWeek: 0,
        },
        {
            loanOptionId: 84,
            repaymentPerWeek: 0,
        },
        {
            loanOptionId: 85,
            repaymentPerWeek: 0,
        },
    ],
    feesAndCharges: [
        {
            interestRate: 16,
            establishmentFee: 250,
            monthlyServiceFee: 15,
            loanTypeId: 83,
            loanType: 'Standard',
            cappedAmount: 50000,
        },
        {
            interestRate: 16,
            establishmentFee: 250,
            monthlyServiceFee: 15,
            loanTypeId: 84,
            loanType: 'Standard',
            cappedAmount: 50000,
        },
        {
            interestRate: 8.99,
            establishmentFee: 250,
            monthlyServiceFee: 15,
            loanTypeId: 85,
            loanType: 'Standard',
            cappedAmount: 100000,
        },
        {
            interestRate: 7.5,
            establishmentFee: 250,
            monthlyServiceFee: 15,
            loanTypeId: 83,
            loanType: 'Green',
            cappedAmount: 50000,
        },
        {
            interestRate: 7.01,
            establishmentFee: 250,
            monthlyServiceFee: 15,
            loanTypeId: 84,
            loanType: 'Green',
            cappedAmount: 50000,
        },
        {
            interestRate: 6.49,
            establishmentFee: 250,
            monthlyServiceFee: 15,
            loanTypeId: 85,
            loanType: 'Green',
            cappedAmount: 100000,
        },
    ],
    applyNowClicked: false,
};

export const netBankSlice = createSlice({
    name: 'netBank',
    initialState,
    reducers: {
        updateApplicationNumber: (state, action: PayloadAction<string>) => {
            state.applicationNumber = action.payload;
        },
        updateSelectedLoanPurposeId: (state, action: PayloadAction<number>) => {
            state.loanPurposeId = action.payload;
        },
        updateSelectedSubLoanPurposeId: (state, action: PayloadAction<number>) => {
            state.subLoanPurposeId = action.payload;
        },
        updateSelectedLoanProductName: (state, action: PayloadAction<string>) => {
            state.loanProductName = action.payload;
        },
        updateLoanTypeName: (state, action: PayloadAction<string>) => {
            state.loanTypeName = action.payload;
        },
        updateTotalLoanAmount: (state, action: PayloadAction<number>) => {
            state.totalLoanAmount = action.payload;
        },
        updateLoanTerm: (state, action: PayloadAction<number>) => {
            state.loanTerm = action.payload;
        },
        updateStandardRate: (state, action: PayloadAction<RateInfo[]>) => {
            state.standardRate = action.payload;
        },
        updateFeesAndCharges: (state, action: PayloadAction<FeesAndCharges[]>) => {
            state.feesAndCharges = action.payload;
        },
        updateApplyNowClickedStatus: (state, action: PayloadAction<boolean>) => {
            state.applyNowClicked = action.payload;
        },
    },
});

export const {
    updateApplicationNumber,
    updateSelectedLoanPurposeId,
    updateSelectedSubLoanPurposeId,
    updateSelectedLoanProductName,
    updateLoanTypeName,
    updateTotalLoanAmount,
    updateLoanTerm,
    updateStandardRate,
    updateFeesAndCharges,
    updateApplyNowClickedStatus,
} = netBankSlice.actions;

export default netBankSlice.reducer;
